import React, { useEffect, useState } from "react";
import { useHistory } from "react-router";
import { CardContent, CardActions, Button, Alert } from "@deere/fuel-react";
import { GridActionsCellItem } from '@mui/x-data-grid';
import { getSubtierMasterData, deleteSubtierMaster } from "../../services/survey.service";
import { deleteSubtier } from "../../services/subtier.service";
import { useOktaAuth } from '@okta/okta-react'
import { useLocation } from 'react-router-dom'
import { DataGridPro, GridToolbar } from '@mui/x-data-grid-pro';
import MoreIcon from '@mui/icons-material/MoreVertOutlined';
import Menu from "@mui/material/Menu";
import MenuItem from "@mui/material/MenuItem";
import DeleteIcon from '@mui/icons-material/DeleteOutlined';
import { SUBTIER_MENU_ACTIONS, SUBTIER_ADMIN_TITLE, GRAL_VALIDATION_MSGS } from "../../utils/constants";
import { GenericFuelModal } from '../../components/modals/GenericFuelModal';

export default function STAdminPanelMaster({ countryList, setRefreshMasterData, refreshMasterData }) {
  const history = useHistory();
  const [loadingMaster, setLoadingMaster] = useState(true);
  const [subtierMasterList, setSubtierMasterList] = useState([]);
  const [containsError, setContainsError] = useState();
  const { authState } = useOktaAuth();
  const location = useLocation();
  const [selectedRow, setSelectedRow] = React.useState();
  const [contextMenu, setContextMenu] = React.useState(null);
  const [deleted, setDeleted] = useState(false);
  const [showValidationModal, setShowValidationModal] = useState(false);
  
  useEffect(() => {
    if (refreshMasterData || deleted) {
      setLoadingMaster(true)
      getSubtierMasterData(authState.accessToken.accessToken).then((response) => {
        setSubtierMasterList(response.data);
        setLoadingMaster(false)
        setRefreshMasterData(false);
        setDeleted(false)
        if (Array.isArray(response) && response.length === 0) {
          setContainsError('No Golden Records to Display');
        } else {
          setContainsError(null);
        }
      }).catch(err => {
        console.log(err)
        setLoadingMaster(false)
        setRefreshMasterData(false)
        setContainsError('Something went wrong, please try to refresh the page');
      });
    }
  }, [authState.accessToken.accessToken, location.state, deleted, refreshMasterData, setRefreshMasterData]);

  const deleteMasterRow = (subtierSupplierNo) => {
    deleteSubtier(subtierSupplierNo, authState.accessToken.accessToken).then((response) => {
      if(response && response.status === 200 && response.data && response.data.survey_subtier_id){
        const stSubtierId = response.data.survey_subtier_id
        deleteSubtierMaster(stSubtierId, authState.accessToken.accessToken).then((response) => {
          setDeleted(true)
        }).catch(err => {
          console.log(err)
          setContainsError(`Something went wrong while deleting the golden record, please try again later.`);  
          setLoadingMaster(false)
        });
      }else{
        setContainsError(`Something went wrong while deleting the golden record on subtier side, please refresh the page and try again. ${response.status}`);  
        setLoadingMaster(false)
      }
    }).catch(err => {
      console.log(err)
      setContainsError(`Something went wrong while deleting the golden record on subtier side, please try again later.}`);  
      setLoadingMaster(false)
    });
  };

  const showDeleteValidation = (show) => {
    setShowValidationModal(show);
  };

  const masterColumns = [
    {
      field: 'subtierSupplierNo',
      headerName: 'Subtier Supplier Number',
      width: 190,
      align: 'left',
      headerAlign: 'left',
    },
    {
      field: 'supplierName',
      headerName: 'Subtier Supplier Name',
      width: 180,
    },
    {
      field: 'streetAddress',
      headerName: 'Street Address',
      width: 220,
    },
    {
      field: 'country',
      headerName: 'Country',
      width: 110,
    },
    {
      field: 'city',
      headerName: 'City',
      width: 110,
    },
    {
      field: 'state',
      headerName: 'State',
      width: 110,
    },
    {
      field: 'postalCode',
      headerName: 'Postal Code',
      width: 110,
    },
    {
      field: 'actions',
      type: 'actions',
      headerName: 'Actions',
      width: 70,
      cellClassName: 'actions',
      getActions: ({ id }) => {
        return [
          <GridActionsCellItem
            icon={<MoreIcon />}
            label="More"
            color="inherit"
            onClick={(e) => openContextMenu(e, id)}
          />
        ];
      },
    },
  ];

  const handleContextMenu = (event) => {
    event.preventDefault();
    let stId = Number(event.currentTarget.getAttribute("data-id"));
    let stSupplierNo = subtierMasterList.find(st => st.id === stId);
    setSelectedRow(stSupplierNo.subtierSupplierNo);
    setContextMenu(
      contextMenu === null
        ? { mouseX: event.clientX - 2, mouseY: event.clientY - 4 }
        : null
    );
  };

  const handleClose = () => {
    setContextMenu(null);
  };

  const openContextMenu = (e, id) => {
    let stSupplierNo = subtierMasterList.find(st => st.id === id);
    setSelectedRow(String(stSupplierNo.subtierSupplierNo));
    setContextMenu(
      contextMenu === null
        ? { mouseX: e.clientX - 2, mouseY: e.clientY - 4 }
        : null
    );
  };

  return <CardContent>
    {containsError && containsError.length > 0 &&
      <Alert variant={'warning'}>{containsError}</Alert>
    }
    <DataGridPro loading={loadingMaster}
      rows={subtierMasterList ? subtierMasterList : []}
      columns={masterColumns}
      sx={{
        height: 450,
        width: '100%',
        '& .MuiCheckbox-root.Mui-checked': {
          color: '#367c2b',
        },
        '& .MuiDataGrid-row:hover': {
          backgroundColor: "#367c2b14",
        },
        '& .MuiDataGrid-row.Mui-selected': {
          backgroundColor: "#367c2b14",
          ':hover': {
            backgroundColor: "#367c2b14",
          }
        }
      }}
      slots={{ toolbar: GridToolbar }}
      slotProps={{
        row: {
          onContextMenu: handleContextMenu,
          style: { cursor: "context-menu" }
        },
        toolbar: { showQuickFilter: true }
      }}
       />
    <CardActions justifyContent="flex-end">
      <Button size="small" variant="secondary" onClick={(e) => history.goBack()}>
        Back
      </Button>
    </CardActions>
    <Menu
      open={contextMenu !== null}
      onClose={handleClose}
      anchorReference="anchorPosition"
      anchorPosition={
        contextMenu !== null
          ? { top: contextMenu.mouseY, left: contextMenu.mouseX }
          : undefined
      }
      componentsProps={{
        root: {
          onContextMenu: (e) => {
            e.preventDefault();
            handleClose();
          }
        }
      }}
    >
      <MenuItem onClick={() => { handleClose(); showDeleteValidation(true) }}><DeleteIcon /> {SUBTIER_MENU_ACTIONS.DELETE}</MenuItem>
    </Menu>
    <GenericFuelModal title={SUBTIER_ADMIN_TITLE}
      show={showValidationModal}
      message={GRAL_VALIDATION_MSGS.delete_validation}
      secondaryBtn={SUBTIER_MENU_ACTIONS.CANCEL}
      primaryButton={SUBTIER_MENU_ACTIONS.DELETE}
      handleSave={() => { deleteMasterRow(selectedRow); setShowValidationModal(false) }}
      handleClose={() => setShowValidationModal(false)}
    />
  </CardContent>
};